/* eslint-disable no-unused-expressions */
/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
import { min2time, time2min } from '../../helpers/utils';
import exportsFormulas from './exportsFormulas';

export async function getrattrapage(columns, elearningAttempts, elearningTarget, elearningDuration, dataPdf, elearningDurationTarget) {
  const result = dataPdf.userRattrapage;
  const finalData = [];
  if (!result) return ({});
  result.data.sort((a, b) => {
    if (a.name < b.name) {
      return -1;
    }
    if (a.name > b.name) {
      return 1;
    }
    return 0;
  });
  result.data.forEach((element) => {
    let obj = {};
    // si export avant le 17/01/2024 ou appartient à lons-le-saunier, mauvaise formule, sinon bonne formule
    if (dataPdf.exportData.companyId === '64d09984b6d5020026b996c6' && new Date(dataPdf.exportData.updated_at) < new Date('2024-01-17')) {
      obj = exportsFormulas.flawedRattrapageFormula(element, elearningTarget, elearningAttempts, elearningDuration / 60);
      const rowData = [];
      rowData.push(element.name);
      rowData.push(element.firstname);
      (obj.quizPercent < obj.quizTarget)
        ? rowData.push(`${Math.floor(element.percent)}%`)
        : rowData.push(`${Math.floor(element.percent)}%`);
      (obj.unitsPercent < obj.unitsTarget)
        ? rowData.push(`${Math.floor(element.unitsPercent)}%`)
        : rowData.push(`${Math.floor(element.unitsPercent)}%`);
      (obj.timeNote < 10 && elearningDurationTarget && elearningDurationTarget > 0)
        ? rowData.push(min2time(element.time))
        : rowData.push(min2time(element.time));
      rowData.push(obj.note.toFixed(2));
      finalData.push(rowData);
    } else {
      obj = exportsFormulas.rattrapageFormula(element, elearningTarget, elearningAttempts, elearningDuration);
      const rowData = [];
      rowData.push(`${element.name} ${element.firstname}`);
      rowData.push(element.email);
      rowData.push(`${Math.floor(element.percent)}%`);
      rowData.push(`${Math.floor(element.unitsPercent)}%`);
      rowData.push(min2time(element.time));
      rowData.push(obj.note.toFixed(2));
      finalData.push(rowData);
    }
  });

  const content = {
    startY: 70,
    head: [columns],
    body: finalData,
    didParseCell(cell) {
      if (cell.section === 'body') {
        if (cell.column.index === 2 && parseInt(cell.cell.raw.replace('%', ''), 10) < elearningTarget) {
          cell.cell.styles.fillColor = [216, 78, 75];
          cell.cell.styles.textColor = [255, 255, 255];
        } else if (cell.column.index === 4 && time2min(cell.cell.raw) < elearningDuration) {
          cell.cell.styles.fillColor = [216, 78, 75];
          cell.cell.styles.textColor = [255, 255, 255];
        } else if (cell.column.index === 3 && parseInt(cell.cell.raw.replace('%', ''), 10) < elearningAttempts) {
          cell.cell.styles.fillColor = [216, 78, 75];
          cell.cell.styles.textColor = [255, 255, 255];
        }
      }
    },

  };
  return content;
}

export async function getsuccess(columns, elearningAttempts, elearningTarget, elearningDuration, dataPdf, elearningDurationTarget) {
  const result = dataPdf.userSuccess;
  const finalData = [];

  if (!result) return ({});
  result.data.sort((a, b) => {
    if (a.name < b.name) {
      return -1;
    }
    if (a.name > b.name) {
      return 1;
    }
    return 0;
  });
  result.data.forEach((element) => {
    let obj = 0;
    // si export avant le 17/01/2024 ou appartient à lons-le-saunier, mauvaise formule, sinon bonne formule
    if (dataPdf.exportData.companyId === '64d09984b6d5020026b996c6' && new Date(dataPdf.exportData.updated_at) < new Date('2024-01-17')) {
      obj = exportsFormulas.flawedSuccessFormula(element, elearningTarget, elearningAttempts, elearningDuration / 60, elearningDurationTarget);
    } else {
      obj = exportsFormulas.successFormula(element, elearningTarget, elearningAttempts, elearningDuration);
    }

    const rowData = [];
    rowData.push(`${element.name} ${element.firstname}`);
    rowData.push(element.email);
    rowData.push(`${Math.floor(element.percent)}%`);
    rowData.push(`${Math.floor(element.unitsPercent)}%`);
    rowData.push(min2time(element.time));
    rowData.push(obj.note.toFixed(2));
    finalData.push(rowData);
  });

  const content = {
    startY: 115,
    head: [columns],
    body: finalData,
    didParseCell(cell) {
      if (cell.section === 'head') {
        cell.cell.styles.fillColor = [78, 216, 75];
        cell.cell.styles.textColor = [255, 255, 255];
      }
    },
  };
  return content;
}

export async function getnotrack(columns, dataPdf) {
  const result = dataPdf.userNoTrackers;
  const columnsName = [];
  if (!result) return ({});
  result.data.sort((a, b) => {
    if (a.name < b.name) {
      return -1;
    }
    if (a.name > b.name) {
      return 1;
    }
    return 0;
  });
  for (let i = 0; i < 2; i += 1) {
    columnsName.push(columns[i]);
  }

  const finalData = [];

  result.data.forEach((element) => {
    const rowData = [];
    rowData.push(`${element.name} ${element.firstname}`);
    rowData.push(element.email);
    finalData.push(rowData);
  });

  const content = {
    startY: 70,
    head: [columnsName],
    body: finalData,
    didParseCell(cell) {
      if (cell.section === 'head') {
        cell.cell.styles.fillColor = [216, 78, 75];
        cell.cell.styles.textColor = [255, 255, 255];
      }
    },
  };
  return content;
}
